"use client"

import { useState, useEffect } from "react"
import { BellRing, X, Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/components/ui/toast/use-toast"
import { usePushSetup } from "@/hooks/usePushSetup"
import { isPushSupported } from "@/lib/push-client"

export function PushBanner() {
  const { subscribed, dismissed, loading, authenticated, setPushEnabled, dismissBanner } = usePushSetup()
  const [mounted, setMounted] = useState(false)
  const { toast } = useToast()

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true)
  }, [])

  if (!mounted) return null
  if (!authenticated || dismissed || subscribed || !isPushSupported()) return null
  if (typeof Notification !== "undefined" && Notification.permission === "denied") return null

  const handleEnable = async () => {
    const ok = await setPushEnabled(true)
    if (ok) {
      toast({ title: "Notificações do sistema ativadas" })
    } else {
      toast({
        variant: "destructive",
        title: "Não foi possível ativar",
        description: "O navegador bloqueou a permissão de notificações.",
      })
    }
  }

  return (
    <div className="border-b bg-blue-50">
      <div className="container flex items-center justify-between gap-4 px-4 py-2">
        <p className="flex items-center gap-2 text-sm text-gray-700">
          <BellRing className="h-4 w-4 shrink-0 text-blue-600" />
          Ative as notificações do sistema para não perder reservas e mensagens.
        </p>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
            disabled={loading}
            onClick={handleEnable}
          >
            {loading && <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" />}
            Ativar
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={() => dismissBanner()}
            aria-label="Fechar"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  )
}
